export const CHAT_CHART_LEGEND_NAME = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  FILES: 'files',
};
